export const setTextCase = (textCase?: string): string => {
  switch (textCase?.toLowerCase()) {
    case 'upper':
    case 'uppercase':
      return 'uppercase';
    case 'lower':
    case 'lowercase':
      return 'lowercase';
    case 'capitalize':
      return 'capitalize';
    default:
      return 'capitalize';
  }
};

export const toSentenceCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
